module.exports = `${require.publicPath}emptyIcon.992d3d3d.png`;